import { render, staticRenderFns } from "./categorias.vue?vue&type=template&id=1b8e8edf&scoped=true&"
import script from "./categorias.vue?vue&type=script&lang=ts&"
export * from "./categorias.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8e8edf",
  null
  
)

export default component.exports